<main class="">
  <navbar />
  <div class="container-xl container-md container-sm" style="padding-top: 2rem; padding-bottom: 2rem">
    <router-outlet />
  </div>
</main>
